import Toggle from '@/components/ui/Toggle.tsx';
import { ChangeDraftVm } from '@/features/dashboard/bookingChanges/types/ChangeViewModel.ts';
import { ChangeDraftBanner } from '@/features/dashboard/bookingChanges/components/layout';
import { ChangeEditAvailabilityVm } from '@/features/dashboard/bookingChanges/components/editing';
import { draftScopeLabel } from './bookingHeaderPresentation';

interface BookingDetailsBannerProps {
  draft: ChangeDraftVm;
  isEditing: boolean;
  editLock: ChangeEditAvailabilityVm;
  onResumeEditing: () => void;
  onWithdrawPackage?: () => void;
  isWithdrawing?: boolean;
  /** Filtr treści zakładek; przełącznik stoi w belce, więc stan idzie tędy. */
  onlyChanged: boolean;
  onOnlyChangedChange: (onlyChanged: boolean) => void;
}

/**
 * Belka otwartego szkicu na ekranie rezerwacji. Osobno od wspólnej
 * `ChangeDraftBanner`, bo tylko tutaj zakres liczy się dla całej paczki
 * i tylko tutaj w belce siedzi przełącznik „Tylko zmienione”.
 */
const BookingDetailsBanner = ({
  draft,
  isEditing,
  editLock,
  onResumeEditing,
  onWithdrawPackage,
  isWithdrawing,
  onlyChanged,
  onOnlyChangedChange,
}: BookingDetailsBannerProps) => (
  <ChangeDraftBanner
    draft={draft}
    isEditing={isEditing}
    subject="paczki zmian"
    scopeLabel={draftScopeLabel(draft, isEditing)}
    editLock={editLock}
    onResumeEditing={onResumeEditing}
    onWithdrawPackage={onWithdrawPackage}
    isWithdrawing={isWithdrawing}
    onlyChangedToggle={
      <Toggle
        size="sm"
        label="Tylko zmienione"
        checked={onlyChanged}
        onCheckedChange={onOnlyChangedChange}
      />
    }
  />
);

export default BookingDetailsBanner;
